import anime            from 'animejs/lib/anime.es.js'
import autosize         from 'autosize'
import randombytes      from 'randombytes'
import { v4 as uuidv4 } from 'uuid'
import * as fields      from './fields'
import * as helpers     from './helpers'

export default class InlineForm
{
	init (form)
	{
		this.params = app_form_params || []
		this.form = form
		this.body = form.querySelector('.body')
		this.prev = form.querySelector('.prev')
		this.next = form.querySelector('.next')
		this.send = form.querySelector('.send')
		this.message = form.querySelector('.message')
		this.info = form.querySelector('.info')
		this.steps = form.querySelector('.steps')
		this.error = form.querySelector('.error')
		this.show_steps = form.dataset.steps
		this.show_progress = form.dataset.progress
		this.animating = false
		this.fields = []
		
		form.querySelectorAll('.fields input').forEach((el) =>
		{
			this.fields = [...this.fields, {
				name: el.dataset.name,
				type: el.dataset.type,
				label: el.dataset.label,
				required: el.dataset.required
			}]
		})
		
		for (let field of this.fields)
		{
			const uuid = uuidv4({ random: randombytes(16) })
			const label = document.createElement('div')
			const step = document.createElement('span')
			
			let input
			
			if (field.type === 'textarea' || field.type === 'select')
			{
				input = document.createElement(field.type)
			}
			else
			{
				input = document.createElement('input')
				
				if (field.type === 'checkbox')
				{
					input.type = 'checkbox'
				}
				else
				{
					input.type = 'text'
				}
			}
			
			field.uuid = uuid
			
			input.name = field.name
			step.dataset.uuid = uuid
			label.dataset.uuid = uuid
			if (field.required)
			{
				label.classList.add('required')
			}
			label.innerHTML = field.type === 'checkbox' ? 'Choix' : (field.label || '#' + this.fields.indexOf(field))
			input.dataset.uuid = uuid
			
			this.form.querySelector('.labels').appendChild(label)
			this.body.querySelector('.inputs').appendChild(input)
			
			if (this.show_steps)
			{
				this.steps.appendChild(step)
			}
		}
		
		const progress = document.createElement('div')
		
		progress.classList.add('progress')
		
		if (this.show_progress)
		{
			this.body.appendChild(progress)
		}
		
		this.progress = this.form.querySelector('.progress')
		
		const label = document.createElement('div')
		
		label.classList.add('custom')
		this.form.querySelector('.labels').appendChild(label)
		
		this.labels = this.form.querySelectorAll('.labels div')
		this.inputs = this.form.querySelectorAll('input, textarea')
		
		this.renderField(this.fields[0].uuid)
		//this.prev.style['transform'] = 'translateX(-100%)';
		//this.send.style['transform'] = 'translateX(-100%)';
		
		for (let step of Array.from(this.steps.querySelectorAll('span')))
		{
			step.addEventListener('click', (e) =>
			{
				this.clickStep(e)
			})
		}
		
		for (let input of Array.from(this.inputs))
		{
			input.addEventListener('keyup', (e) =>
			{
				if (e.keyCode === 13 && input.localName === 'input')
				{
					this.clickNext(e)
				}
			})
		}
		
		this.prev.addEventListener('click', (e) =>
		{
			this.clickPrev(e)
		})
		
		this.next.addEventListener('click', (e) =>
		{
			this.clickNext(e)
		})
		
		this.send.addEventListener('click', (e) =>
		{
			this.clickSend(e)
		})
		
		autosize(this.form.querySelectorAll('textarea'))
	}
	
	getCurrentField ()
	{
		let current_field = this.fields.filter((el) => el.active)[0]
		
		return current_field || null
	}
	
	getPrevField ()
	{
		const current_field = this.getCurrentField()
		const current_field_index = this.fields.indexOf(current_field)
		
		if (!current_field)
		{
			return this.fields[this.fields.length - 1]
		}
		
		return this.fields[current_field_index - 1]
	}
	
	getNextField ()
	{
		const current_field = this.getCurrentField()
		const current_field_index = this.fields.indexOf(current_field)
		
		if (!current_field)
		{
			return
		}
		
		return this.fields[current_field_index + 1]
	}
	
	updateNav ()
	{
		if (this.fields[0].active)
		{
			this.animate({
				targets: this.prev,
				translateX: '-100%',
				complete: () =>
				{
					this.prev.style['visibility'] = 'hidden'
				}
			})
		}
		else
		{
			this.animate({
				targets: this.prev,
				translateX: 0,
				begin: () =>
				{
					this.prev.style['visibility'] = 'visible'
				}
			})
		}
		
		if (!this.fields.filter((el) => el.active).length)
		{
			this.animate({
				targets: this.next,
				translateX: '100%',
				complete: () =>
				{
					this.next.style['visibility'] = 'hidden'
				}
			})
		}
		else
		{
			this.animate({
				targets: this.next,
				translateX: 0,
				begin: () =>
				{
					this.next.style['visibility'] = 'visible'
				}
			})
		}
	}
	
	updateProgress ()
	{
		const fields_done = this.fields.filter((el) => el.done)
		const progress = fields_done.length * 100 / this.fields.length + '%'
		
		if (this.show_progress)
		{
			this.animate({
				targets: this.progress,
				width: progress
			})
		}
		
		if (this.show_steps)
		{
			for (let field of this.fields)
			{
				let step = this.steps.querySelector('[data-uuid="' + field.uuid + '"]')
				
				if (field.done)
				{
					step.classList.add('done')
				}
				else
				{
					step.classList.remove('done')
				}
				
				if (field.active)
				{
					step.classList.add('active')
				}
				else
				{
					step.classList.remove('active')
				}
			}
		}
	}
	
	clickPrev ()
	{
		if (this.animating)
		{
			return
		}
		
		const current_field = this.getCurrentField()
		const prev_field = this.getPrevField()
		
		/*if (current_field && !this.validateField()) {
		 return;
		 }*/
		
		//const nav = Array.from(this.steps.querySelectorAll('span')).filter((el) => el.dataset.uuid === current_field.uuid)[0];
		
		if (current_field && current_field.value && this.current_input.value !== current_field.value)
		{
			this.setError('Un champ modifié doit être validé')
			return
		}
		
		if (prev_field)
		{
			if (current_field)
			{
				//current_field.value = this.current_input.value.trim();
			}
			else
			{
				this.renderValidationBack()
			}
			
			//prev_field.done = false;
			
			//this.current_input.value = '';
			this.renderField(prev_field.uuid)
			//this.updateProgress();
		}
	}
	
	clickNext ()
	{
		if (this.animating)
		{
			return
		}
		
		const current_field = this.getCurrentField()
		const next_field = this.getNextField()
		
		if (current_field && !this.validateField())
		{
			return
		}
		
		//const nav = Array.from(this.steps.querySelectorAll('span')).filter((el) => el.dataset.uuid === current_field.uuid)[0];
		//nav.classList.add('done');
		
		if (current_field)
		{
			current_field.value = this.current_input.value.trim()
			current_field.done = true
			
			//this.updateProgress();
		}
		
		if (next_field)
		{
			//this.current_input.value = '';
			this.renderField(next_field.uuid)
		}
		else
		{
			if (current_field)
			{
				//this.fields.filter((el) => el.active)[0].active = false;
				current_field.active = false
			}
			
			this.renderValidation()
		}
	}
	
	clickStep (e)
	{
		const target_field = this.fields.filter((el) => el.uuid === e.target.dataset.uuid)[0]
		const current_field = this.getCurrentField()
		
		if (!target_field.done)
		{
			return
		}
		
		if (current_field && target_field.uuid === current_field.uuid)
		{
			return
		}
		
		/*if (current_field && !this.validateField()) {
		 return;
		 }*/
		
		if (current_field && current_field.value && this.current_input.value !== current_field.value)
		{
			this.setError('Un champ modifié doit être validé')
			return
		}
		
		if (current_field)
		{
			//current_field.value = this.current_input.value.trim();
		}
		else
		{
			this.renderValidationBack()
		}
		
		this.renderField(e.target.dataset.uuid)
		//this.updateProgress();
		//this.updateNav();
		
		/*if (target_field.done && (!this.steps.querySelector('.active') || this.steps.querySelector('.active') && target_field.uuid !== this.steps.querySelector('.active').dataset.uuid)) {
		 this.renderField(e.target.dataset.uuid);
		 }*/
	}
	
	clickSend ()
	{
		if (this.animating)
		{
			return false
		}
		
		this.removeError()
		
		for (let field of this.fields)
		{
			if (!this.validateField(field))
			{
				return
			}
		}
		
		const timeline = this.timeline()
		
		timeline.add({
			targets: this.send,
			opacity: 0,
			complete: () =>
			{
				this.send.style['visibility'] = 'hidden'
			}
		}).add({
			targets: this.prev,
			translateX: '-100%',
			complete: () =>
			{
				this.prev.style['visibility'] = 'hidden'
				this.checkForm()
			}
		}, 0)
		
		/*const req = async () =>
		 {
		 //let data = await response.json();
		 
		 return await fetch('form/form.php', {
		 method: 'POST',
		 body: JSON.stringify(this.fields),
		 headers: {
		 'Content-Type': 'application/json',
		 'X-Requested-With': 'XMLHttpRequest'
		 }
		 }).then((response) =>
		 {
		 return response.ok ? response.json() : Promise.reject('Impossible d\'envoyer le formulaire')
		 }).then(data =>
		 {
		 return data
		 }).catch((error) =>
		 {
		 return error
		 })
		 }
		 
		 setTimeout(() =>
		 {
		 req().then((response) =>
		 {
		 if (response !== 'success')
		 {
		 this.setError(response)
		 
		 timeline.add({
		 targets: this.send,
		 opacity: [0, 1],
		 begin: () =>
		 {
		 this.send.style['visibility'] = 'visible'
		 }
		 }).add({
		 targets: this.prev,
		 translateX: 0,
		 begin: () =>
		 {
		 this.prev.style['visibility'] = 'visible'
		 }
		 }, 300)
		 }
		 else
		 {
		 timeline.add({
		 targets: this.progress,
		 width: 0
		 })
		 
		 for (let step of Array.from(this.steps.querySelectorAll('span')))
		 {
		 step.classList.remove('active')
		 step.classList.remove('done')
		 }
		 
		 this.renderLabel('Merci !')
		 this.renderMessage('Le formulaire a été envoyé')
		 
		 /!*for (let node of Array.from(this.inputs)) {
		 node.remove();
		 }*!/
		 this.prev.remove()
		 this.next.remove()
		 this.send.remove()
		 }
		 })
		 }, 300)*/
	}
	
	checkForm ()
	{
		const timeline = this.timeline()
		
		let data = helpers.serializeForm(this.form, 'inline')
		
		if (data.error)
		{
			timeline.add({
				targets: this.send,
				opacity: [0, 1],
				begin: () =>
				{
					this.send.style['visibility'] = 'visible'
				}
			}).add({
				targets: this.prev,
				translateX: 0,
				begin: () =>
				{
					this.prev.style['visibility'] = 'visible'
				}
			})
			
			this.setError(data.message)
			return false
		}
		
		this.sendForm(data)
	}
	
	sendForm (data)
	{
		const timeline = this.timeline()
		
		data += '&action=process_form&post_id=' + this.params.post_id + '&security=' + this.params.form_nonce
		
		helpers.req(this.form, this.params.ajax_url, data, 'inline').then((response) =>
		{
			if (!response.success)
			{
				this.setError(response.data.message)
				
				timeline.add({
					targets: this.send,
					opacity: [0, 1],
					begin: () =>
					{
						this.send.style['visibility'] = 'visible'
					}
				}).add({
					targets: this.prev,
					translateX: 0,
					begin: () =>
					{
						this.prev.style['visibility'] = 'visible'
					}
				}, 300)
			}
			else
			{
				timeline.add({
					targets: this.progress,
					width: 0
				})
				
				for (let step of Array.from(this.steps.querySelectorAll('span')))
				{
					step.classList.remove('active')
					step.classList.remove('done')
				}
				
				this.renderLabel('Merci !')
				this.renderMessage('Le formulaire a été envoyé')
				
				/*for (let node of Array.from(this.inputs)) {
				 node.remove();
				 }*/
				this.prev.remove()
				this.next.remove()
				this.send.remove()
			}
		}).catch((error) =>
		{
			this.setError(error)
		})
	}
	
	renderField (uuid)
	{
		
		for (let field of this.fields)
		{
			field.active = field.uuid === uuid
		}
		
		/*for (let step of Array.from(this.steps.querySelectorAll('span'))) {
		 if (step.dataset.uuid === uuid) {
		 step.classList.add('active');
		 } else {
		 step.classList.remove('active');
		 }
		 }*/
		
		this.renderLabel()
		this.renderInput()
		this.removeError()
		this.updateProgress()
		this.updateNav()
	}
	
	/*animate(node, type) {
	 const current_field = this.getCurrentField();
	 const prev_field = this.getPrevField();
	 let current_el = node;
	 let prev_el;
	 
	 if (current_field && NodeList.prototype.isPrototypeOf(node)) {
	 current_el = Array.from(node).filter((el) => el.dataset.uuid === current_field.uuid)[0];
	 }
	 
	 return anime({
	 targets: node,
	 translateY: (type === 'show') ? ['100%', 0] : '-100%',
	 easing: 'easeOutQuart',
	 duration: 400,
	 delay: 200,
	 begin: () => {
	 this.animating = true;
	 
	 if (type === 'show') {
	 node.style['visibility'] = 'visible';
	 }
	 },
	 complete: () => {
	 this.animating = false;
	 
	 if (type === 'hide') {
	 for (let el of node) {
	 if (el !== current_el) {
	 el.style['visibility'] = 'hidden';
	 }
	 }
	 }
	 }
	 })
	 }*/
	
	renderLabel (str = null)
	{
		const current_field = this.getCurrentField()
		
		this.animate({
			targets: this.labels,
			translateY: '-100%',
			delay: 100,
			complete: () =>
			{
				for (let el of Array.from(this.labels))
				{
					if (!current_field || el.dataset.uuid !== current_field.uuid)
					{
						if (!el.classList.contains('custom'))
						{
							el.style['visibility'] = 'hidden'
						}
					}
				}
			}
		})
		
		if (current_field)
		{
			const current_label = Array.from(this.labels).filter((el) => el.dataset.uuid === current_field.uuid)[0]
			
			this.animate({
				targets: current_label,
				translateY: ['100%', 0],
				delay: 100,
				begin: () =>
				{
					current_label.style['visibility'] = 'visible'
				}
			})
		}
		else
		{
			if (str)
			{
				const custom_label = Array.from(this.labels).filter((el) => el.className === 'custom')[0]
				
				this.animate({
					targets: custom_label,
					translateY: ['100%', 0],
					delay: 100,
					begin: () =>
					{
						custom_label.innerHTML = str
						custom_label.style['visibility'] = 'visible'
					}
				})
			}
		}
	}
	
	renderInput ()
	{
		this.renderTextarea()
		
		const current_field = this.getCurrentField()
		const timeline = this.timeline()
		
		timeline.add({
			targets: this.inputs,
			translateY: '-100%',
			complete: () =>
			{
				this.current_input.focus()
				
				for (let el of Array.from(this.inputs))
				{
					if (!current_field || el.dataset.uuid !== current_field.uuid)
					{
						el.style['visibility'] = 'hidden'
					}
				}
			}
		})
		
		if (current_field)
		{
			timeline.add({
				targets: this.current_input,
				translateY: ['100%', 0],
				begin: () =>
				{
					this.current_input.style['visibility'] = 'visible'
				}
			}, 0)
		}
	}
	
	renderTextarea ()
	{
		const current_field = this.getCurrentField()
		
		const nodes = this.form.querySelectorAll('.body, .inputs')
		//const initial_height = window.getComputedStyle(this.inputs[0], null).minHeight
		const initial_height = 70
		const textareas = Array.from(this.inputs).filter((el) => el.tagName.toLowerCase() === 'textarea')
		
		const animeHeight = (e) =>
		{
			this.animate({
				targets: nodes,
				height: (e.target) ? e.srcElement.scrollHeight : e
			})
		}
		
		for (let textarea of Array.from(textareas))
		{
			textarea.removeEventListener('autosize:resized', animeHeight)
			textarea.value = textarea.value.trim()
			autosize.update(textarea)
		}
		
		if (current_field)
		{
			this.current_input = Array.from(this.inputs).filter((el) => el.dataset.uuid === current_field.uuid)[0]
			
			this.current_input.placeholder = this.getPlaceholder(current_field)
			this.current_input.value = current_field.value || this.current_input.value
			
			if (current_field.type === 'textarea')
			{
				animeHeight(this.current_input.scrollHeight)
				
				this.current_input.addEventListener('autosize:resized', animeHeight)
			}
			else
			{
				animeHeight(initial_height)
			}
		}
		else
		{
			animeHeight(initial_height)
		}
	}
	
	renderMessage (str, padding)
	{
		const timeline = this.timeline({
			targets: this.message
		})
		
		timeline.add({
			targets: this.message,
			//translateY: '-100%',
			opacity: 0,
			complete: () =>
			{
				this.message.style['visibility'] = 'hidden'
			}
		})
		
		if (str)
		{
			timeline.add({
				targets: this.message,
				//translateY: ['100%', 0],
				opacity: [0, 1],
				begin: () =>
				{
					if (padding)
					{
						this.message.style['padding-right'] = this.send.offsetWidth + parseInt(window.getComputedStyle(this.send, null).right) + 'px'
					}
					else
					{
						this.message.style['padding-right'] = 0
					}
					
					this.message.innerHTML = str
					this.message.style['visibility'] = 'visible'
				}
			})
		}
	}
	
	renderValidation ()
	{
		this.removeError()
		this.renderLabel('Confirmer l\'envoi')
		this.renderInput()
		this.renderMessage('Modifiez ou envoyez le formulaire', true)
		this.updateProgress()
		this.updateNav()
		
		this.send.style['visibility'] = 'visible'
		
		const offset = parseInt(window.getComputedStyle(this.send, null).top) + parseInt(window.getComputedStyle(this.send, null).height)
		const timeline = this.timeline({
			delay: 150
		})
		
		timeline.add({
			targets: this.send,
			//opacity: [0,1],
			//scale: [0, 1]
			translateY: [-offset, 0]
		})
	}
	
	renderValidationBack ()
	{
		this.renderMessage()
		
		const offset = parseInt(window.getComputedStyle(this.send, null).top) + parseInt(window.getComputedStyle(this.send, null).height)
		const timeline = this.timeline()
		
		timeline.add({
			targets: this.send,
			//opacity: 0,
			//scale: 0,
			translateY: [0, -offset],
			complete: () =>
			{
				this.send.style['visibility'] = 'hidden'
				this.message.style.removeProperty('padding-right')
			}
		})
	}
	
	getPlaceholder (field)
	{
		switch (field.type)
		{
			case 'phone':
				return '00 00 00 00 00 ou +00 0 00 00 00 00'
			case 'email':
				return 'email@domaine.com'
			case 'url':
				return 'www.domaine.fr'
			default:
				return ''
		}
	}
	
	setError (error)
	{
		let anim = true
		
		if (this.error.innerHTML !== '')
		{
			anim = false
		}
		
		this.error.innerHTML = error
		if (anim)
		{
			this.animate({
				targets: this.error,
				opacity: 1
			})
		}
	}
	
	removeError ()
	{
		this.animate({
			targets: this.error,
			opacity: 0,
			complete: () =>
			{
				this.error.innerHTML = ''
			}
		})
	}
	
	validateField (field = null)
	{
		let current_field
		let value
		
		if (field)
		{
			current_field = field
			value = current_field.value
		}
		else
		{
			current_field = this.getCurrentField()
			value = this.current_input.value
		}
		
		const validate = fields.validate(current_field, value, 'inline')
		
		if (validate.error)
		{
			this.setError('Vérifiez ce champ')
			return false
		}
		
		return true
	}
	
	animate (params)
	{
		return anime({
			...{
				easing: 'easeOutQuart',
				duration: 400,
				begin: () =>
				{
					this.animating = true
				},
				complete: () =>
				{
					this.animating = false
				}
			}, ...params
		})
	}
	
	timeline (params)
	{
		return anime.timeline({
			...{
				easing: 'easeOutQuart',
				duration: 400,
				begin: () =>
				{
					this.animating = true
				},
				complete: () =>
				{
					this.animating = false
				}
			}, ...params
		})
	}
}
